module.exports = __webpack_public_path__ + "img/4.4a7677d8.png";